import SMFormFeedback from './SMFormFeedback';

export default SMFormFeedback;
